import axios from "axios";
import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Input, ListGroup, ListGroupItem } from "reactstrap";
import Swal from "sweetalert2";

import useDarkModeClass from "../../../hooks/useDarkModeClass";
import { refresh } from "../../../store/adminSlice";
import createThemedSwal from "../../../utils/sweetAlertWithTheme";

const OrderItem = ({ ele, i }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [updateItem, setUpdateItem] = useState(false);
  const [orderItem, setOrderItem] = useState({});
  const isDarkMode = useDarkModeClass();
  const themedSwal = createThemedSwal(isDarkMode);

  useEffect(() => {
    setOrderItem(ele);
  }, [ele]);

  const handelDelete = (id) => {
    themedSwal
      .fire({
        title: "Do you want to delete this item?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "Delete",
        denyButtonText: `Don't Delete`,
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          axios
            .delete(`/alibaba/api/v1/orderItem/${id}/`)
            .then(() => Swal.fire(`Deleted!`, "", "success"))
            .catch((err) => {
              if (err.response?.status === 401 && Cookies.get("logss")) {
                dispatch(refresh()).then(() => handelDelete(id));
              } else if (
                err.response?.status === 401 &&
                !Cookies.get("logss")
              ) {
                navigate("/");
              } else {
                toast.error("Error occurred");
              }
            });
        } else if (result.isDenied) {
          Swal.fire("Order did not canceled", "", "info");
        }
      });
  };

  const handelEditItem = (id) => {
    setUpdateItem(false);
    axios
      .patch(`/alibaba/api/v1/orderItem/${id}/`, orderItem)
      .then((data) => {
        themedSwal.fire({
          icon: data?.status === 200 ? "success" : "error",
          title: data?.status === 200 ? "success" : "FAILED",
          text: data?.data?.message,
          // footer: '<a href="#">Why do I have this issue?</a>'
        });
      })
      .catch((err) => {
        if (err.response?.status === 401 && Cookies.get("logss")) {
          dispatch(refresh()).then(() => handelEditItem(id));
        } else if (err.response?.status === 401 && !Cookies.get("logss")) {
          navigate("/");
        } else {
          themedSwal.fire({
            icon: "error",
            title: "Oops...",
            text: err?.response?.data?.message || err.message,
          });
        }
      });
  };

  return (
    <ListGroup>
      <ListGroupItem>
        <span className="fw-bold">Item {i + 1}</span>
      </ListGroupItem>
      <ListGroupItem>
        <span className="fw-bold">Spec ID : </span>
        {updateItem ? (
          <Input
            type="text"
            value={orderItem.spec_id}
            className="flex-fill mx-1"
            onChange={(e) =>
              setOrderItem({
                ...orderItem,
                spec_id: e.target.value,
              })
            }
          />
        ) : (
          orderItem.spec_id
        )}
      </ListGroupItem>
      <ListGroupItem>
        <span className="fw-bold">Quantity : </span>
        {updateItem ? (
          <Input
            type="text"
            value={orderItem.quantity}
            className="flex-fill mx-1"
            onChange={(e) =>
              setOrderItem({
                ...orderItem,
                quantity: e.target.value,
              })
            }
          />
        ) : (
          orderItem.quantity
        )}
      </ListGroupItem>
      <ListGroupItem
        onClick={() =>
          !updateItem &&
          window.open(
            `https://detail.1688.com/offer/${orderItem.offer_id}.html`,
            "_blank",
          )
        }
      >
        <span className="fw-bold">Offer ID : </span>
        {updateItem ? (
          <Input
            type="text"
            value={orderItem.offer_id}
            className="flex-fill mx-1"
            onChange={(e) =>
              setOrderItem({
                ...orderItem,
                offer_id: e.target.value,
              })
            }
          />
        ) : (
          orderItem.offer_id
        )}
        {!updateItem && (
          <i
            class="fa fa-external-link-square mx-1"
            aria-hidden="true"
            role="button"
          ></i>
        )}
      </ListGroupItem>
      <ListGroupItem>
        <span
          className="btn btn-primary btn-sm btn-delete mb-0 b-r-4"
          type="button"
          title="delete order"
          onClick={() => handelDelete(orderItem.id)}
        >
          <i className="fa fa-trash"></i>
        </span>
        <span
          className="btn btn-secondary btn-sm btn-delete mb-0 b-r-4 mx-1"
          type="button"
          title="edit item"
          onClick={() => {
            if (updateItem) {
              handelEditItem(orderItem.id);
            } else {
              setUpdateItem(true);
            }
          }}
        >
          <i className={`fa fa-${updateItem ? "save" : "edit"}`}></i>
        </span>
        {updateItem && (
          <span
            className="btn btn-info btn-sm btn-delete mb-0 b-r-4 mx-1"
            type="button"
            title="cancel edit item"
            onClick={() => setUpdateItem(false)}
          >
            <i className="fa fa-times text-white"></i>
          </span>
        )}
      </ListGroupItem>
    </ListGroup>
  );
};

export default OrderItem;
